<script>
// Initialize the annoying-background directive.
export default {
  inserted(el, binding, vnode) {
    const store = vnode.context.$store;
    let havePermission = false;
    const permissions = binding.value.split('|');
    vnode.elm.setAttribute('data-permission', binding.value);
    if (permissions) {
      Promise.all(permissions.map(async (permission) => {
        const match = await store.getters['Usuario/hasPermission'](permission);
        if (match) {
          havePermission = true;
        }
        await new Promise((resolve) => {
          if (!havePermission) {
            try {
              const comment = document.createComment(
                `<!--Permiso denegado: ${binding.value} -->`
              );
              vnode.elm.parentElement.replaceChild(comment, vnode.elm);
            } catch (e) {
              console.error(e);
            }
          }
          setTimeout(resolve, 10);
        });
      }));
    }
  }
};
</script>
